import {UIMSceneEnum} from '../../../../../../shared/enums/UIMSceneEnums'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {UIMSceneController} from '../../UIMSceneController'

export class UIMNavigationController {
    private readonly navigationContainer: HTMLDivElement
    private readonly animatedSlider: HTMLDivElement

    private readonly rankingTab: HTMLDivElement
    private readonly lobbyTab: HTMLDivElement
    private readonly playTab: HTMLDivElement
    private readonly storeTab: HTMLDivElement
    private readonly profileTab: HTMLDivElement

    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        this.navigationContainer = document.getElementById('bottom-nav-container') as HTMLDivElement
        this.animatedSlider = document.getElementById('bottom-nav-animated-slider') as HTMLDivElement

        this.rankingTab = document.getElementById('bottom-nav-ranking-tab') as HTMLDivElement
        this.lobbyTab = document.getElementById('bottom-nav-lobby-tab') as HTMLDivElement
        this.playTab = document.getElementById('bottom-nav-play-tab') as HTMLDivElement
        this.storeTab = document.getElementById('bottom-nav-store-tab') as HTMLDivElement
        this.profileTab = document.getElementById('bottom-nav-profile-tab') as HTMLDivElement

        this.sceneController = sceneController

        this.slideToTab()
        this.handleStoreFeatureHide()
    }

    private slideToTab() {
        this.rankingTab.onclick = () => this.sceneController.loadScene(UIMSceneEnum.Leaderboard)
        this.lobbyTab.onclick = () => this.sceneController.loadScene(UIMSceneEnum.Lobby)
        this.playTab.onclick = () => this.sceneController.loadScene(UIMSceneEnum.Homepage)
        this.storeTab.onclick = () => this.sceneController.loadScene(UIMSceneEnum.Store)
        this.profileTab.onclick = () => this.sceneController.loadScene(UIMSceneEnum.Profile)
    }

    moveSliderTo(tab: UIMSceneEnum) {
        const percentageToMove = UIUtilsEjsVariables.shouldHideStoreOnMobile ? 25 : 20
        const shouldMakeProfileFourthSection = UIUtilsEjsVariables.shouldHideStoreOnMobile && tab == UIMSceneEnum.Profile
        const updatedTabPosition = shouldMakeProfileFourthSection ? tab - 1 : tab
        this.animatedSlider.style.left = `${updatedTabPosition * percentageToMove}%`
    }

    hide() {
        this.navigationContainer.style.display = 'none'
    }

    show() {
        this.navigationContainer.style.display = 'grid'
    }

    handleStoreFeatureHide() {
        if(UIUtilsEjsVariables.shouldHideStoreOnMobile != true) return
        this.navigationContainer.style.gridTemplateColumns = 'repeat(4, 1fr)'
        this.animatedSlider.style.width = '25vw'
        this.animatedSlider.style.left = '50%'
    }
}
